module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('time', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    class: _vm.cssClass,
    attrs: {
      "title": _vm.tooltipTitle(_vm.time),
      "data-placement": _vm.tooltipPlacement,
      "data-container": "body"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.timeFormated(_vm.time)) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b61a630c"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/time_ago_tooltip.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b61a630c"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/time_ago_tooltip.vue
// module chunks = common_vue